import { css } from '@emotion/react';
import ClickableContainer from 'components/clickable-container';
import { gray2, primary, white } from 'styles/global_defaults/colors';


const PILL_HEIGHT = 35;

type Props = {
  text: string;
  selected: boolean;
  className?: string;
  onClick: () => void;
  dataQa?: string;
  dataQaId?: string;
};

const PillButton = ({
  text,
  selected,
  className,
  onClick,
  dataQa,
  dataQaId,
}: Props) => {
  const styles = css`
    height: ${PILL_HEIGHT}px;
    text-wrap: nowrap;
    border-radius: ${PILL_HEIGHT / 2}px;

    color: ${gray2};
    background-color: ${white};

    ${selected ? css`
      color: ${white};
      background-color: ${primary};
    ` : css`
      &:hover {
        color: ${primary};
      }
    `}
  `;

  return (
    <ClickableContainer
      css={styles}
      data-qa={dataQa}
      data-qa-id={dataQaId}
      onClick={onClick}
      aria-label={text}
      aria-pressed={selected}
      className={`px-4 align-items-center justify-content-center font-weight-bold text-medium ${className ?? ''}`}
    >
      {text}
    </ClickableContainer>
  );
};

export default PillButton;
